import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Empleados } from '../models/Empleados';
import { Lentes } from '../models/Lentes';
import { Becas } from '../models/Becas';
import { Observable, throwError } from 'rxjs';
import { Ortopedicos } from '../models/Ortopedicos';
import { catchError, tap } from 'rxjs/operators';
import { Facmanual } from '../models/Facmanual';


@Injectable({
  providedIn: 'root'
})
export class InventarioService {

  API_URI = environment.uri_api;

  constructor(private http: HttpClient) { }


///////////////resguardantes/////////////////
getListadeempleados(idplantel: number){

    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.get(`${this.API_URI}/listadeempleados/${idplantel}`,{headers:httpHeaders});
  }

  createempleado (empleados: Empleados, mailuser: string ){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });

  return this.http.post(`${this.API_URI}/crear/empleado/${mailuser}`, empleados,{headers:httpHeaders});
}

 getEmpleadoId(id: number){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });


  return this.http.get(`${this.API_URI}/empleadoinformacion/${id}`,{headers:httpHeaders});

}

updateempleado (id: any, empleados: Empleados) {

  console.log("el id que va a mandar en updateAsignatura "+id);
  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });

  return this.http.put(`${this.API_URI}/editarempleados/${id}`, empleados,{headers:httpHeaders});
}

deleteempleado (id:any){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });

  return this.http.delete(`${this.API_URI}/elimiarempleado/${id}`,{headers:httpHeaders});
}


getPlantelCatalogo(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/plantelcatalogo`,{headers:httpHeaders});
  }

getEmpleadoCatalogo(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/empleadocatalogoss`,{headers:httpHeaders});
  }



 getLesteslista(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/lenteslistas`,{headers:httpHeaders});
  }



createLentes (lentes: Lentes, mailuser: string ){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });

  return this.http.post(`${this.API_URI}/crear/lentes/${mailuser}`, lentes,{headers:httpHeaders});
}
validarApoyosLentes(numempleado: string, periodo: string) {
  var t = localStorage.getItem('token');

  const httpHeaders = new HttpHeaders({
    'content-type': 'application/json',
    'Authorization': '' + t
  });

  return this.http.get(`${this.API_URI}/validar/lentes/${numempleado}/${periodo}`, { headers: httpHeaders });
}


getPeriodoCatalogo(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/periodocatalogoss`,{headers:httpHeaders});
  }
deletelentes (id:any){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });

  return this.http.delete(`${this.API_URI}/elimiarlentes/${id}`,{headers:httpHeaders});
}

pagarlentes(id: any, fechaPago: string | null, quincena: string, estatus: number) {

  const t = localStorage.getItem('token');
  const headers = new HttpHeaders({
    'content-type': 'application/json',
    'Authorization': '' + t
  });

  return this.http.put(
    `${this.API_URI}/registrolentespago/${id}`,
    { fechaPago, quincena, estatus },
    { headers }
  );
}

getlentesId(id: number){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });


  return this.http.get(`${this.API_URI}/lentesinformacion/${id}`,{headers:httpHeaders});

}

updateLentes (id: any, lentes: Lentes) {

  console.log("el id que va a mandar en updateAsignatura "+id);
  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });

  return this.http.put(`${this.API_URI}/editarlentes/${id}`, lentes,{headers:httpHeaders});
}

 getBecaslista(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/becaslistas`,{headers:httpHeaders});
  }

//   pagarbecas (id:any){

//   var t=localStorage.getItem('token');

//   const httpHeaders=new HttpHeaders({
//     'content-type':'application/json',
//     'Authorization': ''+t
//   });

//   return this.http.delete(`${this.API_URI}/registrobecaspago/${id}`,{headers:httpHeaders});
// }

pagarbecas(id: number, fechaPago: string | null, quincena: string, estatus: number) {
  const t = localStorage.getItem('token');
  const headers = new HttpHeaders({
    'Authorization': t ?? '',
    'Content-Type': 'application/json'
  });

  return this.http.put(
    `${this.API_URI}/registrobecaspago/${id}`,
    { fecha_pagonomina: fechaPago, quincena, estatus },
    { headers }
  );
}


createBecas(becas: Becas, mailuser: string) {
  const t = localStorage.getItem('token');

  const httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': t ?? ''
  });

  return this.http.post(`${this.API_URI}/crear/becas/${mailuser}`, becas, { headers: httpHeaders });
}

getbecasId(id: number){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });


  return this.http.get(`${this.API_URI}/becasinformacion/${id}`,{headers:httpHeaders});

}

getxmlId(id: string){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });


  return this.http.get(`${this.API_URI}/xmlnformacion/${id}`,{headers:httpHeaders});

}

getxmllentesId(id: string){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });


  return this.http.get(`${this.API_URI}/xmlnformacionlentes/${id}`,{headers:httpHeaders});

}

deletebecas (id:any){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });

  return this.http.delete(`${this.API_URI}/elimiarbecas/${id}`,{headers:httpHeaders});
}

getxmlOrtopId(id: string){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });


  return this.http.get(`${this.API_URI}/xmlnformacionortope/${id}`,{headers:httpHeaders});

}


updateBecas(id: any, becas: any, mailuser: string) {
  const t = localStorage.getItem('token');

  const httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': t ?? ''
  });

  return this.http.put(`${this.API_URI}/actualizar/becas/${id}/${mailuser}`, becas, { headers: httpHeaders });
}

subirXML(formData: FormData): Observable<any> {
    const t = localStorage.getItem('token'); // Si tu backend requiere token
    const headers = new HttpHeaders({
      'Authorization': t ?? ''
      // NO incluir Content-Type, el navegador lo asigna automáticamente para FormData
    });

    return this.http.post(`${this.API_URI}/subirxml`, formData, { headers });
  }

guardarXMLmanual(data: any) {
  const t = localStorage.getItem('token');
  const headers = new HttpHeaders({
    'Authorization': t ?? '',
    'Content-Type': 'application/json'
  });

  return this.http.post(
    `${this.API_URI}/guardarxmlmanual`,
    data,
    { headers }
  );
}

guardarXMLmanuallentes(data: any) {
  const t = localStorage.getItem('token');
  const headers = new HttpHeaders({
    'Authorization': t ?? '',
    'Content-Type': 'application/json'
  });

  return this.http.post(
    `${this.API_URI}/guardarxmlmanuallentes`,
    data,
    { headers }
  );
}

guardarXMLmanualortopedicos(data: any) {
  const t = localStorage.getItem('token');
  const headers = new HttpHeaders({
    'Authorization': t ?? '',
    'Content-Type': 'application/json'
  });

  return this.http.post(
    `${this.API_URI}/guardarxmlmanualortopedico`,
    data,
    { headers }
  );
}



 getXMLlista(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/XMLslistas`,{headers:httpHeaders});
  }

//////////////////////////////////
getOrtopedicoslista(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/ortopedicoslistas`,{headers:httpHeaders});
  }
  
createOrtopedicos(ortopedicos: Ortopedicos, mailuser: string) {
  const t = localStorage.getItem('token');

  const httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': t ?? ''
  });

  return this.http.post(`${this.API_URI}/crear/ortopedicos/${mailuser}`, ortopedicos, { headers: httpHeaders });
}


pagarortopedico(id: number, fecha_pago: string | null, quincena_pago: string, pagado: number, mailuser: string) {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    'Authorization': token ?? '',
    'Content-Type': 'application/json'
  });

  return this.http.put(
    `${this.API_URI}/registroortopedicopago/${id}/${mailuser}`,
    { fecha_pago, quincena_pago, pagado },
    { headers }
  );
}


getortopedicoId(id: number){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });


  return this.http.get(`${this.API_URI}/ortopedicossinformacion/${id}`,{headers:httpHeaders});

}

deleteortopedicos (id:any){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });

  return this.http.delete(`${this.API_URI}/elimiarortopedicos/${id}`,{headers:httpHeaders});
}

updateOrtopedicos(id: any, ortopedicos: any, mailuser: string) {
  const t = localStorage.getItem('token');

  const httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': t ?? ''
  });

  return this.http.put(`${this.API_URI}/actualizar/ortopedicos/${id}/${mailuser}`, ortopedicos, { headers: httpHeaders });
}

//////////////////EXCEL REPORTES//////////////////
 getListaBecasExcel(idplantel: number){

    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.get(`${this.API_URI}/listabecasExcel/${idplantel}`,{headers:httpHeaders});
  }
 getListaBecasExcelpagado(idplantel: number){

    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.get(`${this.API_URI}/listabecasExcelpagado/${idplantel}`,{headers:httpHeaders});
  }



 getListaLentesExcel(idplantel: number){

    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.get(`${this.API_URI}/listalentesExcel/${idplantel}`,{headers:httpHeaders});
  }

 getListaLentesPagadoExcel(idplantel: number){

    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.get(`${this.API_URI}/listalentespagaExcel/${idplantel}`,{headers:httpHeaders});
  }


   getListaOrtopedicosExcel(idplantel: number){

    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.get(`${this.API_URI}/listaortopedicosExcel/${idplantel}`,{headers:httpHeaders});
  }


     getListaOrtopedicospagadoExcel(idplantel: number){

    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.get(`${this.API_URI}/listaortopedicospagaExcel/${idplantel}`,{headers:httpHeaders});
  }

 getPlantillaempleadosExcel(idplantel: number){

    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.get(`${this.API_URI}/listaplantillaempleaExcel/${idplantel}`,{headers:httpHeaders});
  }


 getPlanteles(id: number){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    return this.http.get(`${this.API_URI}/Plantelesid/${id}`,{headers:httpHeaders});

  }

getTodosPlanteles() {
  const t = localStorage.getItem('token');
  const httpHeaders = {
    'content-type': 'application/json',
    'Authorization': '' + t
  };
  return this.http.get(`${this.API_URI}/Planteles`, { headers: httpHeaders });
}


 getLesteslistasiga(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/lenteslistassiga`,{headers:httpHeaders});
  }
//////////////////////////////////
getFacturasSinPoliza() {
  const token = localStorage.getItem('token');
  return this.http.get(
    `${this.API_URI}/facturas`,
    { headers: { Authorization: '' + token } }
  );
}

crearPoliza(body: any) {
  const token = localStorage.getItem('token');
  return this.http.post(
    `${this.API_URI}/polizas`,
    body,
    { headers: { Authorization: '' + token } }
  );
}

////////// MATERIALES ///////////

 getFacturasMateriales(): Observable<any> {
  
    var t=localStorage.getItem('token');
   const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    return this.http.get(`${this.API_URI}/facturas-materiales`, { headers:httpHeaders });
  }

/**
 * Crear nueva factura (manual / XML)
 */
guardarFacturaMaterial(payload: any): Observable<any> {
  const token = localStorage.getItem('token') || '';

  const httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: '' + token
  });

  return this.http.post(
    `${this.API_URI}/guardarxmlmanuales`,
    payload,
    { headers: httpHeaders }
  ).pipe(
    tap(res => console.log('Creación OK:', res)),
    catchError(err => {
      console.error('Error creación:', err);
      return throwError(() => err);
    })
  );
}



/**
 * ACTUALIZAR factura materiales + facturas
 */
actualizarFacturaMaterial(id: number | string, payload: any): Observable<any> {
  const token = localStorage.getItem('token') || '';

  const httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: '' + token
  });

  return this.http.put(
    `${this.API_URI}/actualizarxmlmanual/${id}`,
    payload,
    { headers: httpHeaders }
  ).pipe(
    tap(res => console.log('Actualización OK:', res)),
    catchError(err => {
      console.error('Error actualización:', err);
      return throwError(() => err);
    })
  );
}



///////////////////////////////
getPolizaslistaRH(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/polizarhlistas`,{headers:httpHeaders});
  }
 
getpolizasId(id: number){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });



  return this.http.get(`${this.API_URI}/polizarhinformacion/${id}`,{headers:httpHeaders});

}
////////////////////////////////////
getXMLOrtopedico(id: number) {
  const token = localStorage.getItem('token') || '';

  const headers = new HttpHeaders({
    'content-type': 'application/json',
    'Authorization': '' + token
  });

  return this.http.get(
    `${this.API_URI}/factura-xml/${id}`,
    { headers }
  );
}

actualizarPoliza(id: number, body: any) {
  const token = localStorage.getItem('token');
  return this.http.put(
    `${this.API_URI}/polizas/${id}`,
    body,
    { headers: { Authorization: '' + token } }
  );
}

///////////////////////////////////
Listaempleadosviaticos(idplantel: number) {

    var t = localStorage.getItem('token');

    const httpHeaders = new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '' + t
    });

    return this.http.get(`${this.API_URI}/listaempleadosviaticos/${idplantel}`, { headers: httpHeaders });
  }


/////////////reportes/////////////
reportePolizasConFacturas(body: any) {
  const token = localStorage.getItem('token');
  return this.http.post<any[]>(
    `${this.API_URI}/reportes/polizas-con-facturas`,
    body,
    { headers: { Authorization: '' + token } }
  );
}

reporteFacturasProveedor(body: any) {
  const token = localStorage.getItem('token');
  return this.http.post<any[]>(
    `${this.API_URI}/reportes/facturas-proveedor`,
    body,
    { headers: { Authorization: '' + token } }
  );
}
/////////////reporte financieros//////////////

reportePolizasConFacturasTXT(body: any) {
  const token = localStorage.getItem('token');
  return this.http.post<any[]>(
    `${this.API_URI}/reportes/polizas-con-facturas-txt`,
    body,
    { headers: { Authorization: '' + token } }
  );
}

eliminarPoliza(id: number) {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': '' + token
  });

  return this.http.delete(`${this.API_URI}/polizaeliminar/${id}`, { headers });
}

///////////////////////
getempleadosss(){

      var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    return this.http.get(`${this.API_URI}/empleados-facturas-materiales`,{headers:httpHeaders});
}

subirfactura(facturasmanual: Facmanual) {
  const t = localStorage.getItem('token');

  const httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': t ?? ''
  });

 return this.http.post(`${this.API_URI}/crear/manual`, facturasmanual, {headers:httpHeaders});
}

eliminarFactura(uuid: string, folio: string) {

  const token = localStorage.getItem('token') || '';

  const httpHeaders = new HttpHeaders({
    Authorization: token
  });

  return this.http.delete(
    `${this.API_URI}/eliminarfacturamaterial`,
    {
      headers: httpHeaders,
      body: {
        uuid,
        folio
      }
    }
  );
}

}